var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bill-print-dialog',{attrs:{"state":_vm.dialog,"bill":_vm.bill}})}
var staticRenderFns = []

export { render, staticRenderFns }